import React from 'react';
import { Typography } from '@material-ui/core';
import { ColumnProps } from 'components/@common/Table/LwtTable';
import { TFunction } from 'i18next';
import {
  appendSecondsOrFallback,
  getDefaultText
} from 'components/ReportsModule/components/KeyboardingReport/keyboarding-report-util';

const Title = ({ children }: any) => (
  <Typography style={{ fontSize: 12, fontWeight: 600 }}>{children}</Typography>
);

const getSingleModuleColumns: (t: TFunction) => ColumnProps<any>[] = (t: TFunction) => {
  const main: ColumnProps<any> = {
    id: 'questionType',
    label: <Title>{t('Question Type')}</Title>,
    sortKey: 'questionType',
    getValue: item => <Typography>{item.questionType}</Typography>,
    sortable: true
  };

  return [
    main,
    {
      id: 'timeToAnswer',
      label: <Title>{t('Avg Time Per Question')}</Title>,
      sortKey: 'timeToAnswer',
      getValue: item => <Typography>{appendSecondsOrFallback(item.timeToAnswer)}</Typography>,
      sortable: true
    },
    {
      id: 'noOfTimeCompleted',
      label: <Title>{t('Questions Completed')}</Title>,
      sortKey: 'noOfTimeCompleted',
      getValue: item => <Typography>{getDefaultText(item.noOfTimeCompleted)}</Typography>,
      sortable: true
    },
    {
      id: 'avgNoOfTries',
      label: <Title>{t('Avg Tries Per Question')}</Title>,
      sortKey: 'avgNoOfTries',
      getValue: item => <Typography>{getDefaultText(item.avgNoOfTries)}</Typography>,
      sortable: true
    },
    {
      id: 'noOfQuestionAnswered',
      label: <Title>{t('Questions Answered In One Try')}</Title>,
      sortKey: 'noOfQuestionAnswered',
      getValue: item => <Typography>{item.noOfQuestionAnswered ?? '-'}</Typography>,
      sortable: true
    }
  ];
};

export default getSingleModuleColumns;
